var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-action-sheet',{attrs:{"actions":_vm.actions,"cancel-text":"取消","close-on-click-action":""},on:{"select":_vm.onSelect,"cancel":_vm.close},model:{value:(_vm.showSheet),callback:function ($$v) {_vm.showSheet=$$v},expression:"showSheet"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }